<template>
  <div class="main-container">
    <!-- Author: Vaishnavi
      Date: 10/12/2019
      Issue Description: Breadcrumb alignment -->
    <breadcrumb :list="breadcrumbList" />
    <!-- <under-construction></under-construction> -->

    <div class="grid-title margintop-16" v-if="tabIndex === 0">
      <span> Total Active Employees </span>
      <span> </span>
      <span> </span>
      <span> </span>
      <span> </span>
      <span class="text-center total-employee-count"
        ><strong>{{ activeList.length }}</strong></span
      >
      <span><strong> </strong></span>
      <span><strong> </strong></span>
      <span><strong> </strong></span>
      <span><strong> </strong></span>
    </div>

    <div class="grid-title margintop-16" v-if="tabIndex === 1">
      <span> Total Exits Employees </span>
      <span> </span>
      <span> </span>
      <span> </span>
      <span> </span>
      <span class="text-center total-employee-count"
        ><strong>{{ existList.length }}</strong></span
      >
      <span><strong> </strong></span>
      <span><strong> </strong></span>
      <span><strong> </strong></span>
      <span><strong> </strong></span>
    </div>

    <div class="margintop-32">
      <tl-tabs :tabs="tabs" :selected="tabIndex" @changeTab="parentTabChange">
        <tl-tab>
          <active :activeEmployeeList="activeList" :tableData="activeList"></active>
        </tl-tab>
        <tl-tab>
          <exits :existEmployeeList="existList" :tableData="existList"></exits>
        </tl-tab>
      </tl-tabs>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import active from "./active.vue";
import exits from "./exits.vue";

export default {
  components: {
    active,
    exits,
  },
  data() {
    return {
      tabIndex: 0,
      breadcrumbList: [
        {
          name: "Company",
          url: `/dashboard/${this.$route.params.entity_index}/organisation`,
        },
        {
          name: "Employee Directory",
          url: `/dashboard/${this.$route.params.entity_index}/organisation/employees`,
        },
      ],
      tabs: [
        {
          header: "Active",
        },
        {
          header: "Exits",
        },
      ],
      showTag: true,
      showSuccessMsg: false,
      actionTypeVar: "",
      showPopup: false,
      employeeData: [],
      activeList: [],
      existList: [],
    };
  },
  mounted() {
    this.fetchemp();
    this.activeExistEmployeeList();
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
    }),
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
    },
    requestParams() {
      return {
        le_id: this.le_id,
      };
    },
  },
  methods: {
    ...mapActions({
      act_fetch: "onboard/employees/fetchAll",
      act_deletee: "onboard/employees/deletee",
      activeExistEmployee: "dashboard/organisation/employeeDirectory/fetchAll",
    }),
    async fetchemp() {
      //console.log("edit");
      try {
        let res = await this.act_fetch();
        //console.log("inside added", res.data.payload.data);
        this.employeeData = res.data.payload.data;
      } catch (err) {
        //console.log(err);
        this.toast = true;
        this.errmsg = err;
      }
    },

    async activeExistEmployeeList() {
      try {
        let res = await this.activeExistEmployee({
          le_id: this.le_id,
        });
        if (res.data.status) {
          this.activeList = res.data.payload.finalActiveEmployeeList;
          this.existList = res.data.payload.finalExitEmployeeList;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    removeTag() {
      this.showTag = false;
    },

    routeToMainStep() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation`,
      });
    },
    actionType(val) {
      this.actionTypeVar = val;
      //console.log("action type clickd", this.actionTypeVar);
      //console.log("inside action type");
      if (this.actionTypeVar === "assignRole") {
        this.showPopup = true;
      }
    },
    changecheckbox(val) {
      this.role = val;
      //console.log("radio", val);
    },
    cancel() {
      this.showPopup = false;
    },
    save() {
      this.showPopup = false;
      this.showSuccessMsg = true;
    },
    backToOrg() {
      this.showSuccessMsg = false;
      this.$router.push({
        path: "dashboard/organisation/employees",
      });
    },
    parentTabChange(tabIndex) {
      this.tabIndex = tabIndex;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss";
.nav {
  color: #555555;
  font-size: 11px;
  margin-left: 10px;
}
.grid-title {
  display: grid;
  grid-template-columns: 4fr 4fr 4fr 4fr 4fr;
  grid-template-rows: 2fr;
  grid-gap: 4px;
  padding: 10px;
  color: #646464;
  font-size: 16px;

  b {
    font-size: 24px;
  }
}
.modal {
  display: block;
  position: fixed;
  z-index: 6;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.3);
}

.modal-content-history {
  background-color: white;
  margin: 60px auto 0px auto;
  z-index: 20;
  width: 500px;
  height: 375px;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  padding: 30px 36px 36px 0px;

  .datatableClass {
    margin-left: 10%;
    margin-top: 5%;
    overflow-y: scroll;
  }
}
.top-bar {
  background-color: #34c0be;
  display: flex;
  width: 108%;
  height: 85px;
  margin-top: -30px;
}
.heading_new {
  font-family: Montserrat;
  font-size: 22px;
  font-weight: bold;
  padding: 10px;
  color: #ffffff;
}
.imagearea {
  display: flex;

  img {
    padding: 10px;
    margin-left: 5%;
    width: 90px;
    height: 90px;
  }
}
.emp-header {
  padding: 20px 0px 0px 10px;
  display: flex;
  .text {
    font-size: 16px;
    color: #646464;
    margin-right: 10px;
  }

  .line {
    border-bottom: 1px solid #34c0be;
    flex-grow: 1;
  }
}

.filters-section {
  display: flex;
  align-items: flex-end;
  margin-top: 30px;
  margin-left: 10px;
  // overflow: scroll;
  *:nth-child(1) {
    margin-right: 10px;
  }
}

.selectdiv {
  select {
    max-width: 200px;
    border-radius: 4px;
    outline: 0;
    font-size: 14px;
    color: #9c9c9c;
    border: 1px solid #dadada;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    /* SVG background image */
    // background: url("@/assets/stroke-1.png");
    background-size: 12px;
    background-position: calc(100% - 10px) center;
    background-repeat: no-repeat;

    option {
      color: #9c9c9c;
      font-size: 12px;
    }
  }
  span {
    color: #b3b3b3;
    font-size: 12px;
  }
}
.filters-button {
  margin-top: 10px;
  width: 95px;
  height: 35px;
  cursor: pointer;
  font-size: 12px;
  border-radius: 4px;
  color: #555555;
  border: 1px solid #37c6c0;
}
.search-bar {
  padding: 30px 0px 0px 10px;
  display: flex;
}
.addnewempbtn {
  width: 130%;
  display: flex;
  justify-content: center;
  height: 30px;
  background-color: #5d409f;
  border: #5d409f solid 1px;
  color: #ffffff;
  margin-left: 10px;
  border-radius: 4px;
  align-items: center;
  *:nth-child(n) {
    margin-right: 5px;
  }
}
.export-section {
  margin-left: 6%;
  margin-top: -8px;
  align-items: center;
  display: flex;
}
.export-button {
  width: 70px;
  height: 25px;
  border-radius: 4px;
  font-family: Montserrat;
  font-size: 12px;
  text-align: center;
  border: 1px solid #5d409f;
  color: #5d409f;
  margin-left: 3px;
}
.sort-by {
  display: flex;
  margin-left: 7%;

  span {
    margin-right: 10px;
    margin-top: 10px;
    color: #b3b3b3;
    font-size: 12px;
  }
}
.side-actions {
  margin-left: 10px;
  margin-top: 10px;
  img {
    cursor: pointer;
    margin-right: 5px;
    margin-left: 5px;
  }
}
.ver-line {
  border-right: solid 1px #30b6bc;
  padding-top: 10px;
}
.employee-cards {
  padding: 30px 0 0 10px;
}
.btnGrp {
  margin-left: 33px;
}
.align-filters {
  display: flex;
  margin: 30px 0 0 10px;
  *:nth-child(1) {
    text-align: center;
  }
  button {
    // margin: 30px 0 0 10px;
    // width: 120px;
    // height: 28px;
    // display: flex;
    border-radius: 100px;
    background-color: #b2f8f7;

    // span {
    //   margin-left: 10px;
    // }
    // img {
    //   margin-left: 56%;
    //   margin-top: 3px;
    // }
  }
}
.filters {
  width: 125px;
  height: 28px;
  display: flex;
  justify-content: space-between;
  margin-left: 10px;
  *:nth-child(1) {
    margin-right: 10px;
    padding-left: 5px;
  }
  img {
    margin-top: 3px;
    margin-right: 10px;
    cursor: pointer;
  }
}
.save-tags {
  margin-left: 10px;
  span {
    font-size: 12px;
    cursor: pointer;
  }
}
.btn-popup {
  display: block;
  border-radius: 4px;
  height: 35px;
  width: 120px;
  align-self: center;
  background-color: #5d409f;
  color: #ffffff;
}
.clear-filters {
  font-size: 12px;
  margin-top: 7px;
  margin-left: 19px;
  cursor: pointer;
}
.alignCss {
  padding: 28px;
  margin-bottom: 100px;
}

.card-container {
  width: 100%;
}
.employee {
  width: 32%;
  height: 210px;
  border-radius: 10px;
  border: solid 1px #f2f2f2;
  display: inline-flex;
  background-color: #ffffff;
  margin: 0px 10px 10px 0px;
}
.employee-img {
  position: relative;
  width: 51%;
  border-right: 1px solid #f2f2f2;
  // opacity: 0.11;
  padding: 18px; // 10px
  height: 100%;
}
.imgDetails {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .link-actions {
    margin-left: 10px;
    display: flex;
    justify-content: space-between;
  }
}
.action-container {
  right: 15px;
  position: absolute;
  display: flex;
  // flex-direction: column;
  img {
    cursor: pointer;
  }
}
.action {
  width: 4px;
  height: 4px;
  margin: 4px;
  color: #000000;
}
.employee-details {
  width: 60%;
  padding: 18px; //12px
  position: relative;
}
.checkbox {
  position: absolute;
  height: 18px;
  width: 18px;
  border-radius: 4px;
  border: 1px solid #f2f2f2;
  background-color: #ffffff;
}
.empId {
  color: #878787;
  font-size: 12px;
  text-align: center;
}
.empName {
  font-family: Montserrat;
  font-size: 14px;
  color: #979797;
  // margin-left: 13px;
  color: #646464;
  font-weight: 500;
}
.empDetails {
  font-family: Montserrat;
  font-size: 12px;
  color: #979797;
  text-align: center;
  // margin-left: 30px;
}
.details {
  font-family: Montserrat;
  font-size: 12px;
  color: #878787;
  img {
    width: 10px;
    height: 10px;
    margin-right: 5px;
  }
}
.link-actions {
  display: flex;
  justify-content: space-around;
  cursor: pointer;
  img {
    width: 13px;
    height: 13px;
  }
}
button {
  margin-top: 10px;
  width: 75px;
  height: 20px;
  cursor: pointer;
  font-size: 12px;
  border-radius: 4px;
  color: #555555;
  border: 1px solid #37c6c0;
}
.joining-time {
  color: #5d409f;
  font-size: 12px;
  margin-top: 10px;
}
.offer-status {
  color: #5d409f;
  font-size: 12px;
  cursor: pointer;
}

.action-container-icon {
  margin-left: 98%;
}
.action-menu {
  width: 128px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.23);
  background-color: #ffffff;
  margin-right: 10px;
  border-right: 20px solid #ffffff;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;

  .edit {
    cursor: pointer;
    // margin-left: 5px;
    font-size: 12px;
    padding: 5px 0px 5px 5px;
    color: #616363;
    width: 120px;
    // text-align: center;

    &:hover {
      border: 1px solid #c0edeb;
      // width: 120px;
      // height: 20px;
      // color:red;
      background-color: #c0edeb;
    }
  }
}
// .selected {
//      &.hover {
//         border: 1px solid #c0edeb;
//         width: 120px;
//         height: 40px;
//         background-color: #c0edeb;
//      }
// }
.action-menu:after {
  filter: drop-shadow(1mm 0mm 0mm rgba(0, 0, 0, 0.23));
  position: absolute;
  width: 0;
  top: 0px;
  right: 5%;
  height: 0;
  content: "";
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 10px solid #ffffff;
  filter: drop-shadow(1mm 0mm 0mm rgba(0, 0, 0, 0.23));
}

.progress-bar {
  margin-top: 20px;
  margin-bottom: 5px;
  width: 108px;
  height: 8px;
  border-radius: 4px;
  border: solid 1px #34c0be;
  background-color: #ffffff;
  position: relative;
}
.progress {
  position: absolute;
  background-color: #b2f8f7;
  width: 50%;
  border-radius: 4px;
  height: 6px;
}
.show-progress {
  padding: 7px;
  color: #5d409f;
  font-size: 12px;
}

.search-container {
  width: 300px;
  position: relative;
  max-width: 321px;
  span {
    position: absolute;
    padding: 10px;
  }
}
.search-bar {
  width: 100%;
  border: 1px solid #d6d4d4;
  border-radius: 3px;
  height: 35px;
  padding: 5px;
  outline: none;
  position: relative;
}
.search-icon {
  position: absolute;
  right: 10px;
  top: 6px;
  width: 18px;
  height: 18px;
  left: inherit;
}

img.search-icon-filter {
  position: relative;
  right: 5px;
  top: 8px;
  width: 24px;
  height: 24px;
  // margin: 38px 6px 29px 32px;
  padding: 7px 4px 6px;
}
span.filter-text {
  font-weight: 600;
  color: #34c0be;
}

.filter-width {
  width: 390px;
}

a.anchor-underline-none {
  text-decoration: none;
}

.line {
  width: 1px;
  height: 18px;
  margin: 0px 13px 0px 1px; //41px 13px 32px 15px;
  opacity: 0.16;
  border: solid 1px #30b6bc;
}

.total-employee-count {
  width: 80%;
}
</style>


